import type { ReactNode } from 'react';
import { isLuckyLoserPlaceholderId } from '@/draw/lucky-loser';

// Public player journeys accept persisted UUID identities only, never synthetic seats.
const PLAYER_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function DrawPlayerLink({
  playerId,
  playerHref,
  children,
}: {
  playerId: string;
  playerHref?: (id: string) => string | undefined;
  children: ReactNode;
}) {
  const href =
    !isLuckyLoserPlaceholderId(playerId) && PLAYER_ID.test(playerId)
      ? playerHref?.(playerId)
      : undefined;
  return href ? (
    <a
      href={href}
      className="hover:underline focus-visible:outline-2"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </a>
  ) : (
    <>{children}</>
  );
}
